<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">

  <el-table
      :data="tableData"
       v-loading="loading"
       style="width: 100%"
       border class="mt-2"
       show-summary
       :summary-method="getSummaries"
       :empty-text="$t('tableText.데이타가없습니다')" @selection-change="handleSelectionChange">
  
  
       <el-table-column
        
        :label="$t('tableText.공급사')" prop="provider_name" align="center">
      </el-table-column>
       <el-table-column
        
        :label="$t('tableText.게임명')" prop="game_title" align="center" >
         
      </el-table-column>

 
          <el-table-column
        :label="$t('tableText.배팅금')" prop="bet" align="center">
        <template slot-scope="scope">
          <span :class="String(scope.row.total_loging) === '2' && (scope.row.type === 'Slots' || scope.row.game_type === 'Slots') ? 'text-danger' : ''">{{formatMoney(scope.row.bet)}}</span>
        </template>
      </el-table-column>

      

       <el-table-column
        :label="$t('tableText.당첨금')" prop="win" align="center">
         <template slot-scope="scope">
          {{formatMoney(scope.row.win)}}
        </template>
      </el-table-column>

      
  
     
    </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
          <div style="flex: 1;" class="px-2">
            <el-pagination
            :current-page="currentPage"
            :page-sizes="[5, 10, 15, 20]"
            :page-size="size"
            layout="prev, pager, next"
            :total="total"
            @size-change="handleSizeChange"
                @current-change="handleCurrentChange">
          </el-pagination>
          </div>
        </el-footer>  
          <id-dialog 
                :visible.sync="idDialogVisible"
                @cancelData="cancelData"
                @handleClose="handleClose"
                
                :formLoading="formLoading"
                ref="addForm">
                  
        </id-dialog>
        
</div>
 </template>

 <script>
 import idDialog from '../../components/common/id-dialog.vue';

    export default {
     components: {
      idDialog
    },
      data(){
        return{
           otp:'',
          disabled:false,
          domain:window.sessionStorage.getItem('domain'),
   sitetype:window.sessionStorage.getItem('sitetype'),
     bg:window.sessionStorage.getItem('bg'),
          formLoading:false,
          idDialogVisible: false,
          buy_good0:'',
          buy_good0_sum:'',
          total_emoney:'',
          total_money:'',
          game_codes:{
               'PWB_NB_MIX':this.$i18n.t("msg.일반조합"),
              'PWB_PB_MIX':this.$i18n.t("msg.파워조합"),
              'PWB_NBPB_MIX':'',
              'PWB':'',
              'PWB_NBPB_MIX3':'',             
            },
         options: [{
                label: this.$i18n.t("msg.대기"),
                value: '1',
               
              }, {
                label: this.$i18n.t("msg.처리중"),
                 value: '2',
                
              }, {
                label: this.$i18n.t("msg.완료"),
                 value: '3',
               
              }, {
                label: this.$i18n.t("msg.취소"),
                 value: '4',
               
              }], 
          searchform:{
            keyword:'',
            time:[],
            searchOptions:[
                
               {
                  label:this.$i18n.t("msg.구매자"),
                  value:'mem_name'
                },
                {
                  label:this.$i18n.t("msg.아이디"),
                  value:'mem_id'
                },
                {
                  label:this.$i18n.t("msg.회차"),
                  value:'buy_num'
                },
                {
                  label:this.$i18n.t("msg.총판"),
                  value:'a_code'
                },
                {
                  label:this.$i18n.t("msg.부본사"),
                  value:'b_code'
                },
           

            ],
            searchOptions2:[
                
            {
             label:this.$i18n.t("msg.전체"),
              value:''
            },{
              label:this.$i18n.t("msg.적중"),
              value:'win'
            },
            {
              label:this.$i18n.t("msg.배팅"),
              value:'bet'
            },
            {
             label:this.$i18n.t("msg.환불"),
              value:'refund'
            },
            {
               label:this.$i18n.t("msg.취소"),
              value:'cancel'
            },
            ],
            searchOptions3:[
            {
              label:this.$i18n.t("msg.전체"),
              value:''
            },
            {
              label:this.$i18n.t("msg.슬롯"),
              value:'Slots'
            },
            {
              label:this.$i18n.t("msg.라이브"),
              value:'Live Casino'
            },
            
            ],
            value:'',
            value2:'',
            value3:'',


          },
           pickerOptions: {
          },
          shortcuts: [{
            text:this.$i18n.t("dateText.최근한주"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근한달"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근3개월"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
    
        
    
   
          
            
        
             total:0,
             size:0,
             loading: false,
             editIndex:-1,
             creatModel:false,
             tableData: [],
               currentPage:1,
               multipleSelection:[],
              
               
       
          }
          
          
        },
        created() {
          

          this.getList();
          
      
    },
    computed:{
      minus(){
        return this.total_money - this.total_emoney
      }

    },
      
      methods:{
          // 关闭弹框（头部的X）
        handleClose () {
               this.idDialogVisible = false
            },
        cancelData(){
          this.idDialogVisible = false
        },
           // 搜索事件
      searchEvent(){

                if(this.searchform.keyword!='' && this.searchform.value == ''){
                   this.$message(this.$i18n.t("msg.검색타이틀선택하세요"));
                   return;
                }

              
            this.currentPage=1;


          this.getList();
          
             

        },
         handleSizeChange(val) {
              //console.log(`每页 ${val} 条`);
              this.size = val
              this.getList();
              this.loading= true

            },
            handleCurrentChange(val) {
              //console.log(`当前页: ${val}`);
              this.currentPage = val
              this.getList();
              this.loading= true
            },
           handleSelectionChange(val) {
          //console.log(val)
                this.multipleSelection = val;

      },
        getSummaries(param) {
        const {
          columns,
          data
        } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = this.$i18n.t("msg.총");
          } else if (index === 2) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          } else if (index === 3) {
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
              sums[index] = this.formatMoney(sums[index]);
            
            } else {
              sums[index] = '/';
            }
          } else {
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
            } else {
              sums[index] = '/';
            }
          }
        });
        return sums;
      },
    
       openModel(e){
          this.idDialogVisible = true
          this.formLoading = true
          let token=window.sessionStorage.getItem('user');
          let that=this
          this.$axios({
                  method:'get',
                  // url:this.domain+'/api/admin/mem_cp_list2?fit='+this.prop+'&order='+this.order,
                   url:this.domain+'/admin/mem?fit='+this.prop+'&order='+this.order+'&mem_id='+e.row.username,

                  'Accept': 'application/json',
                  headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 
                   this.formLoading = false
                   let data = response.data.data
                   //console.log('usersdata:',data)

                   //console.log('mem_status:',data.mem_status)
                   //console.log('addForm:',data.memState)
                   // this.$refs.addForm.form.mem_status = data.mem_status
                  // this.$refs.addForm.form.memState = data.memState
                   this.$refs.addForm.form = {
                      id_txt: data.id_txt,
                      bet_black : data.bet_black,
                      ref:data.ref,
                      mem_name:data.mem_name,
                      mem_hp:data.mem_hp,
                       color:data.RaceYN,
                        sitetype:this.sitetype,
                      mem_ing:data.mem_ing,
                      mem_login:data.mem_login,
                      mem_id:data.mem_id,
                      mem_pw:data.mem_pw,
                      mem_bankcode:data.mem_bankcode,
                      mem_banknum: data.mem_banknum,
                      mem_bankname:data.mem_bankname,
                      bg:this.bg,
                      event_loing1:data.event_loing1,
                      event_loing_recom1:data.event_loing_recom1,
                      event_loing_group1:data.event_loing_group1,
                      event_loing_group_recom1:data.event_loing_group_recom1,

                      event_loing_s1:data.event_loing_s1,
                      event_loing_recom_s1:data.event_loing_recom_s1,
                      event_loing_group_s1:data.event_loing_group_s1,
                      event_loing_group_recom_s1:data.event_loing_group_recom_s1,

                      event_loing_recom_e:data.event_loing_recom_e,
                      event_loing_recom_slot:data.event_loing_recom_slot,
                      event_loing_e:data.event_loing_e,
                      event_loing_slot:data.event_loing_slot,
                      event_boat_sambok : data.event_boat_sambok,
                      event_bokyeon : data.event_bokyeon,
                      event_cycle_sambok : data.event_cycle_sambok,
                      event_japan_sambok : data.event_japan_sambok,
                      event_japan_samsang : data.event_japan_samsang,
                      event_pro : data.event_pro,
                      event_pro_boat : data.event_pro_boat,
                      event_pro_cycle : data.event_pro_cycle,
                      event_pro_japan : data.event_pro_japan,
                      event_sambok : data.event_sambok,
                      event_sang : data.event_sang,
                      login_more : data.login_more,
                      c_code:data.c_code,
                      mem_jumin:data.mem_jumin,
                       mem_email:data.mem_email,
                      mem_zip:data.mem_zip,
                      max_bet:data.max_bet,
                      m_emoney:data.m_emoney,
                      bet_black1 : data.bet_black1,
                      bet_black2 : data.bet_black2,
                      bet_black3 : data.bet_black3,
                      bet_black4 : data.bet_black4,
                      t_delay:data.t_delay,
                      mem_regdate:data.mem_regdate,
                      mem_cash:data.mem_cash,
                      mem_eventmoney:data.mem_eventmoney,
                      mem_ip:data.mem_ip,
                      mem_raip:data.mem_raip,
                      m_cp:data.m_cp,
                      mem_all_init:data.mem_all_init,
                      mem_memo:data.mem_memo,
                      mem_status:data.mem_status,
                       memState:data.memState,
                      loging:data.loging,
                      logip:data.logip,
                      mem_login_date:data.mem_login_date,
                      a_code:data.a_code,
                      last_money_date:data.last_money_date,
                      in_money:data.in_money,
                      out_money:data.out_money,
                      reset_money:data.reset_money,
                      event_loing:data.event_loing,
                      event_loing_recom:data.event_loing_recom,
                      event_loing_group:data.event_loing_group,
                      event_loing_group_recom:data.event_loing_group_recom,
                      last_out_money_date:data.last_out_money_date,
                      reg_code:data.reg_code,
                      out_bet_power:data.out_bet_power,
                      out_bet_power_g:data.out_bet_power_g,
                      out_bet_sadari:data.out_bet_sadari,
                      out_bet_sadari_g:data.out_bet_sadari_g,
                      event_loing_s:data.event_loing_s,
                      event_loing_recom_s:data.event_loing_recom_s,
                      event_loing_group_s:data.event_loing_group_s,
                      event_loing_group_recom_s:data.event_loing_group_recom_s,
                      b_code:data.b_code,
                    }

                   
                     
               
            }).catch((error) =>{
                 console.log('error',error.response)   //请求失败返回的数据
            })
        },
       // 批量删除
      deleteAll(){
        this.$confirm(this.$i18n.t("msg.삭제하시겠습니까"), this.$i18n.t("msg.알림"), {
          confirmButtonText: this.$i18n.t("msg.삭제"),
           cancelButtonText:this.$i18n.t("msg.취소"),
          type: 'warning'
        }).then(() => {
          let token=window.sessionStorage.getItem('user');

          console.log('hh',this.multipleSelection);

                    let newids=[];

           this.multipleSelection.forEach(item=>{
            
            console.log('id',item.id);
            newids.push(item.id);
           });

           console.log('newids',newids);

          this.$axios({
                      method:'post',
                       data:{idx:newids,opt:this.otp},
                      url:this.domain+'/admin/apibet_del',
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                    
                    if(response.data.code==200){
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })
                    }else
                    {
                        this.$message({
                         message:response.data.msg,
                          type:'error'
                        })
                    }
                    this.getList()
    
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                  
       

          })

        
      },  
        getList(){

        

               let s_time="";
               let e_time="";

               if(this.searchform.time.length>0)
               {
                  s_time=this.searchform.time[0];
                  e_time=this.searchform.time[1];
               }

              
          this.loading = true

           let token=window.sessionStorage.getItem('user');
            //console.log(token);
           let urls=this.domain+'/admin/apibetlist3?s_time=2022-06-01&e_time=2023-12-30';

          this.$axios({
                  method:'get',
                  url:urls,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 


                  
                     let data = response.data
                     this.tableData =data.data
                     this.total = 1
                     this.currentPage =1
                     this.size =100
                 
                     this.loading =false
               
            }).catch((error) =>{
            
               this.$message.error(error);
              this.loading = false
               
            })
        }
        
      
        
      }
  }
</script>

 <style scoped>
 /deep/ .el-form-item__content{
    display:flex;
    align-items:center;
    line-height:30px;
 }
 /deep/ .el-dialog{
    height:700px;overflow-y:scroll
 }
 /deep/ .el-input__inner{
  height:30px;
  line-height:30px;
 }
 /deep/ .el-form-item__label{
  line-height:30px;
 }
 /deep/ .el-dialog__body{
  padding:10px 20px
 }

</style>



// WEBPACK FOOTER //
// src/views/betting6/list.vue